const requestPageConstants = {
  STORE_REQUEST_LIST: 'STORE_REQUEST_LIST',
  STORE_PENDING_REQUEST_LIST: 'STORE_PENDING_REQUEST_LIST',
};
export default requestPageConstants;
